module.exports = __webpack_public_path__ + "img/integral_4.ab98aaf4.png";